module.exports = __webpack_public_path__ + "static/media/email.1db2525c.svg";